import { MatSliderModule } from "@angular/material/slider";
import { TranslateModule } from "@ngx-translate/core";
import { NgTemplateOutlet } from "@angular/common";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { Component, contentChild, forwardRef, input, TemplateRef } from "@angular/core";

import { ReactiveFormsBaseComponent } from "../../base-components";

@Component({
  selector: "app-slider",
  standalone: true,
  imports: [MatSliderModule, ReactiveFormsModule, TranslateModule, NgTemplateOutlet],
  templateUrl: "./slider.component.html",
  styleUrl: "./slider.component.scss",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SliderComponent),
      multi: true,
    },
  ],
})
export class SliderComponent extends ReactiveFormsBaseComponent {
  readonly min = input(0); // Minimum value for the range
  readonly max = input(100); // Maximum value for the range
  readonly step = input(1); // Step size for the slider
  readonly unit = input(""); // Unit of the range
  readonly label = input.required<string>();

  unitRef = contentChild("unit", { read: TemplateRef });

  controlValue!: [number, number];

  // Write value from the form control into the component
  override writeValue(value: [number, number]): void {
    if (value) {
      this.controlValue = value;
    }
  }

  // Handle changes in the slider value
  updateValue(newValue: [number, number]): void {
    this.controlValue = newValue;
    this.onChange(newValue);
    this.onTouched(newValue);
  }

  ngOnInit(): void {
    this.controlValue = [this.min(), this.max()]; // Range value [start, end]
  }
}
